import { IichiEnv } from './_env';

export const CdnDomain: Record<IichiEnv, string> = {
  [IichiEnv.DEV]: 'http://localhost',
  [IichiEnv.STAGE]: 'https://cdn.iichi-dev.com',
  [IichiEnv.PROD]: 'https://cdn.iichi.com',
} as const;
export type CdnDomain = (typeof CdnDomain)[keyof typeof CdnDomain];
